<template>
    <div>
        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('reservation_enable') }}
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-switch 
                    :value.sync="reservation_enable"
                    @change="(val) => onchange('reservation_enable',val==true)"
                    :disabled="disabled"
                ></v-switch>
            </v-col>

            <v-col cols="12" md="3" align="left" class="pt-6">
                {{ $t('line_reservation_enable') }}
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-switch 
                    :value.sync="line_reservation_enable"
                    @change="(val) => onchange('line_reservation_enable',val==true)"
                    :disabled="disabled"
                ></v-switch>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                จุดบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_station_dup_day"
                    @change="(val) => onchange('reserve_station_dup_day',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง ภายในวันเดียวกัน
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                จุดบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_station_dup_week"
                    @change="(val) => onchange('reserve_station_dup_week',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง ภายในสัปดาห์เดียวกัน
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                จุดบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_station_dup_month"
                    @change="(val) => onchange('reserve_station_dup_month',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง ภายเดือนวันเดียวกัน
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="3" align="left" class="pt-6">
                จุดบริการเดียวกันห้ามจองเกิน
            </v-col>
            <v-col cols="12" md="2" align="left">
                <v-text-field
                    :value.sync="reserve_station_dup_all"
                    @change="(val) => onchange('reserve_station_dup_all',val)"
                    outlined
                    dense
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" align="left" class="pt-6">
                การจอง รวมทั้งหมด
            </v-col>
        </v-row>

    </div>
</template>

<script>
  export default {
    props: ['reservation_enable','onchange','disabled','line_reservation_enable'
    ,'reserve_station_dup_day','reserve_station_dup_week','reserve_station_dup_month','reserve_station_dup_all'],
    data () {
        return {

        }
    }
  }
</script>